var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as dayjs from 'dayjs';
import { scaleManager } from './scale';
import LinearScale from './linear';
import * as lodash from '../utils/lodash';
import template from '../utils/template';
var intervalList = [
    {
        unit: 'second',
        seconds: 1,
        formatter: 'HH:mm:ss',
        steps: [1, 2, 5, 10, 20, 30],
    },
    {
        unit: 'minute',
        seconds: 60,
        formatter: 'HH:mm',
        steps: [1, 2, 5, 10, 20, 30],
    },
    {
        unit: 'hour',
        seconds: 3600,
        formatter: 'HH:mm',
        steps: [1, 2, 4, 6, 12],
    },
    {
        unit: 'day',
        seconds: 3600 * 24,
        formatter: 'DD',
        steps: [1, 2, 4, 7],
    },
    {
        unit: 'month',
        seconds: 3600 * 24 * 30,
        formatter: 'MM月',
        steps: [1, 2, 3, 6],
    },
    {
        unit: 'year',
        seconds: 365 * 24 * 3600,
        formatter: 'YYYY',
        steps: [1, 2, 3, 4, 5, 10, 20, 50],
    },
];
var ScaleTime = /** @class */ (function (_super) {
    __extends(ScaleTime, _super);
    function ScaleTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'time';
        return _this;
    }
    // eslint-disable-next-line no-unused-vars
    ScaleTime.prototype.niceTicks = function (tickCount, intervalConf) {
        if (intervalConf === void 0) { intervalConf = {}; }
        var _a = this, min = _a.min, max = _a.max;
        var avgInterval = (this.max - this.min) / tickCount;
        var unit = lodash.minBy(intervalList, function (interval) {
            return Math.abs(interval.seconds * 1000 - avgInterval);
        });
        if (!unit) {
            this._timeInterval = intervalList[0];
            this.ticks = [];
            return;
        }
        if (unit.seconds * 1000 > avgInterval) {
            var index = intervalList.indexOf(unit);
            unit = intervalList[index - 1] || intervalList[0];
        }
        this._timeInterval = unit;
        var steps = unit.steps;
        var bestStep = lodash.minBy(steps, function (step) {
            return Math.abs(step * unit.seconds * 1000 - avgInterval);
        });
        var start = dayjs(min).startOf(unit.unit);
        var end = dayjs(max).endOf(unit.unit);
        var startOffset = (start.get(unit.unit) - (unit.unit === 'day' ? 1 : 0)) % bestStep;
        if (unit.unit !== 'year') {
            start = start.add(-startOffset, unit.unit);
        }
        var ticks = [];
        var date = start.clone();
        while (!date.isAfter(end)) {
            ticks.push(date.valueOf());
            date = date.add(bestStep, unit.unit);
        }
        this.min = ticks[0];
        this.max = end.valueOf();
        this.ticks = ticks;
    };
    ScaleTime.prototype.getLabel = function (value) {
        var index = this.ticks.indexOf(value);
        var isFirst = index === 0;
        var isLast = index === this.ticks.length - 1;
        if (lodash.isString(this.formatter)) {
            return template(this.formatter, { value: value, index: index, isFirst: isFirst, isLast: isLast });
        }
        if (lodash.isFunction(this.formatter)) {
            return this.formatter(value, index, { isFirst: isFirst, isLast: isLast });
        }
        return dayjs(value).format(this._timeInterval.formatter);
    };
    return ScaleTime;
}(LinearScale));
scaleManager.registerClass('time', ScaleTime);
export default ScaleTime;
